/**
 * Created by tomers on 1/5/2015.
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");

    var MultiselectModel = BaseModel.extend({
        defaults: {
            asyncFilter: false,
            asyncFilterMinChars: 3,
            floating: true,
            trim: false,
            filterValue: "",
            enterKeyActionAllowed: true,
        },
        setAsyncFilter: function(asyncFilter) {
            this.set("asyncFilter", asyncFilter);
        },
        isAsyncFilter: function() {
            return (this.get("asyncFilter") === true);
        },
        setAsyncFilterMinChars: function(asyncFilterMinChars) {
            this.set("asyncFilterMinChars", asyncFilterMinChars);
        },
        getAsyncFilterMinChars: function() {
            return this.get("asyncFilterMinChars");
        },
        setFloating: function(floating) {
            this.set("floating", floating);
        },
        isFloating: function() {
            return (this.get("floating") === true);
        },
        setTrim: function(trim) {
            this.set("trim", trim);
        },
        isTrim: function() {
            return (this.get("trim") === true);
        },
        getFilterValue: function() {
            return this.get("filterValue");
        },
        setFilterValue: function(filterValue) {
            this.set("filterValue", filterValue);
        },
        setEnterKeyActionAllowed: function (prevent) {
            this.set("enterKeyActionAllowed", prevent);
        },
        isEnterKeyActionAllowed: function () {
            return this.get("enterKeyActionAllowed");
        },
    });


    return MultiselectModel;
});
